<div class="tab-wrapper">
  <abc-tab-panel
    #tabPanel
    class="tab-panel"
    [(selectedIndex)]="selectedIndex"
    [items]="tabItems()"
    [itemTemplate]="'tabContent'"
    itemTitleTemplate="tabTitle"
    [deferRendering]="true"
  >
    <div *dxTemplate="let tab of 'tabTitle'">
      <div
        class="title-card"
        [class.active]="tab.index === selectedIndex"
        [class.inactive]="tab.index != selectedIndex"
      >
        {{ tab.title }}
      </div>
    </div>
    <div *dxTemplate="let tab of 'tabContent'">
      <div class="container-card">
        @switch (tab.index) {
          @case (0) {
            <comments-popup
              fxFill
              [itemId]="measureId()"
              [geoDs]="true"
            ></comments-popup>
          }
          @case (1) {
            <ubt-geods-document
              [showAllDocuments]="false"
              [parentId]="measureId()"
              [documentOpath]="true"
            ></ubt-geods-document>
          }
          @case (2) {
            @if (selectedIndex === 2) {
              <iup-aims-measure-change-history></iup-aims-measure-change-history>
            }
          }
        }
      </div>
    </div>
  </abc-tab-panel>
</div>
